var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home"},[_c('div',{directives:[{name:"view",rawName:"v-view"}],staticClass:"hero"},[_c('div',{staticClass:"hero-bg"})])])}
var staticRenderFns = []

export { render, staticRenderFns }